<template>
  <div>
    <component :is="isPc" :companyIfor="companyIfors"></component>
  </div>
</template>

<script>

import isMobile from "@/common/js/utils/isMobile.js";
import PLyricSearch from "./lyricSearch/PLyricSearch";
import MLyricSearch from "./lyricSearch/MLyricSearch";
export default {
  name: "LyricSearch",
  props: ['companyIfor'],
  data() {
    return {
      isPc: '',
      companyIfors: ''
    };
  },
  created() {
    //判断当前是PC端还是移动端
    if(!isMobile()) {
      this.isPc = PLyricSearch;
    }else {
      this.isPc = MLyricSearch;
    }
  },
  watch: {
    companyIfor: {
      handler(val) {
        this.companyIfors = val;
      },
      deep: true
    }
  }
};
</script>

<style scoped>

</style>